module.exports = __webpack_public_path__ + "static/media/bg.4eb968f6.png";